import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import SortIcon from "@mui/icons-material/Sort";
import styles from "../../styles/common/sortMenu.module.css";

const options = [
  "Number of Proposals",
  "Average Rating",
  "Amount Requested",
  "Funded Amount",
  "Funded Proposals",
  "Proposer",
];

type Sortprops = {
  sortPage: Function;
};

const ProposerSortMenu = (props: Sortprops) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(5);
  const open = Boolean(anchorEl);
  const [sortData, setSortData] = React.useState<{
    order_by: string;
    ordering: string;
  }>({ order_by: "user_name", ordering: "asc" });

  React.useEffect(() => {
    props.sortPage(sortData);
    //eslint-disable-next-line
  }, [sortData]);

  const [showUpArrow, setShowUpArrow] = React.useState<boolean>(true);
  const [showDownArrow, setShowDownArrow] = React.useState<boolean>(false);

  const handleArrowClick = () => {
    setShowUpArrow((prevState) => !prevState);
    setShowDownArrow((prevState) => !prevState);
    setSortData({
      ...sortData,
      ordering: sortData.ordering === "asc" ? "desc" : "asc",
    });
  };

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    setSelectedIndex(index);
    setAnchorEl(null);
    switch (index) {
      case 0:
        setSortData({ ...sortData, order_by: "number_of_proposals" });
        break;
      case 1:
        setSortData({ ...sortData, order_by: "average_rating" });
        break;
      case 2:
        setSortData({ ...sortData, order_by: "amount_requested" });
        break;
      case 3:
        setSortData({ ...sortData, order_by: "funded_amount" });
        break;
      case 4:
        setSortData({ ...sortData, order_by: "funded_proposals" });
        break;
      case 5:
        setSortData({ ...sortData, order_by: "user_name" });
        break;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ButtonGroup
      variant="text"
      aria-label="text button group"
      className={styles.buttonGroup}
    >
      <List>
        <ListItem
          button
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
          className={styles.listItem}
        >
          <SortIcon color="primary" />
          <ListItemText
            primary={options[selectedIndex]}
            className={styles.listItemText}
          />
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
      <IconButton
        size="small"
        sx={{ display: showUpArrow ? "Inline" : "None" }}
        onClick={handleArrowClick}
      >
        <ArrowUpwardIcon fontSize="small" color="primary" />
      </IconButton>

      <IconButton
        size="small"
        sx={{ display: showDownArrow ? "Inline" : "None" }}
        onClick={handleArrowClick}
      >
        <ArrowDownwardIcon fontSize="small" color="primary" />
      </IconButton>
    </ButtonGroup>
  );
};

export default ProposerSortMenu;
